import script from "./AccountApprovalModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountApprovalModal.vue?vue&type=script&setup=true&lang=js"

import "./AccountApprovalModal.vue?vue&type=style&index=0&id=01391ba1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01391ba1"]])

export default __exports__